import { RemoteGetContatoPermissoes } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { PortalContatoPermissoes } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeGetContatoPermissoes = (): PortalContatoPermissoes => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<PortalContatoPermissoes.Result>()

  return new RemoteGetContatoPermissoes(url, httpClient)
}
